import { EVINCED_SEVERITIES, EVINCED_SEVERITIES_IDS, OptionType } from '@evinced-private/ui-common';

import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';
import { MOBILE_PLATFORM, MOBILE_PLATFORM_IDS } from 'src/common/helpers/MobileQueriesHelper';

export const SESSIONS_PERIOD_OPTIONS: OptionType[] = [
	DEFAULT_PERIOD_OPTION,
	{ value: 60, label: 'Last 60 days' },
	{ value: 90, label: 'Last 90 days' },
	{ value: 'all', label: 'All Sessions' }
];

export const PLATFORM_OPTIONS: OptionType[] = [
	{ value: MOBILE_PLATFORM_IDS.ANDROID, label: MOBILE_PLATFORM.ANDROID },
	{ value: MOBILE_PLATFORM_IDS.IOS, label: MOBILE_PLATFORM.IOS }
];

export const SEVERITY_OPTIONS: OptionType[] = [
	{ value: EVINCED_SEVERITIES_IDS.CRITICAL, label: EVINCED_SEVERITIES.CRITICAL },
	{ value: EVINCED_SEVERITIES_IDS.SERIOUS, label: EVINCED_SEVERITIES.SERIOUS },
	{ value: EVINCED_SEVERITIES_IDS.MODERATE, label: EVINCED_SEVERITIES.MODERATE },
	{ value: EVINCED_SEVERITIES_IDS.MINOR, label: EVINCED_SEVERITIES.MINOR },
	{ value: EVINCED_SEVERITIES_IDS.BEST_PRACTICE, label: EVINCED_SEVERITIES.BEST_PRACTICE },
	{ value: EVINCED_SEVERITIES_IDS.NEEDS_REVIEW, label: EVINCED_SEVERITIES.NEEDS_REVIEW }
];
